// Google Analytics 4 mirror. The tag itself is loaded in public/index.html (production hostnames only);
// here we send SPA page views and translate the site's Meta events into GA4 events.
import { getPartnerSlug } from "../pages/public/partnerRef";

const GA_EVENT = {
  PageView: null, // handled by gaPageView
  Lead: "generate_lead",
  CompleteRegistration: "sign_up",
  InitiateCheckout: "begin_checkout",
  Contact: "contact",
  Schedule: "schedule",
  ViewContent: "view_item",
};

const toSnake = (s) => String(s).replace(/([a-z0-9])([A-Z])/g, "$1_$2").replace(/[^a-zA-Z0-9]+/g, "_").toLowerCase();

const ready = () => typeof window !== "undefined" && window.__gaReady && typeof window.gtag === "function";

const withRef = (params) => {
  const ref = getPartnerSlug();
  return ref ? { ...params, partner_ref: ref } : params;
};

export const gaPageView = (path, title) => {
  if (!ready()) return;
  try {
    window.gtag("event", "page_view", withRef({ page_path: path, page_location: window.location.href, page_title: title || document.title }));
  } catch { /* never block UI */ }
};

// `content_name` (Meta's label, e.g. "book_call") becomes GA4's `lead_type`; `content_category` (booking context) becomes `lead_context`.
export const gaEvent = (metaEvent, params = {}) => {
  if (!ready()) return;
  const name = GA_EVENT[metaEvent] === undefined ? toSnake(metaEvent) : GA_EVENT[metaEvent];
  if (!name) return;
  try {
    const { content_name, content_category, value, currency, ...rest } = params || {};
    window.gtag("event", name, withRef({ ...(content_name ? { lead_type: content_name } : {}), ...(content_category ? { lead_context: content_category } : {}), ...(value != null ? { value } : {}), ...(currency ? { currency } : {}), ...rest }));
  } catch { /* never block UI */ }
};
